// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".triple-card a:hover{text-decoration:none}.triple-card .card{border:0;border-radius:10px}.triple-card .card:hover{box-shadow:0 0 30px rgba(36,40,47,.1)}.triple-card .card-title,.triple-card .card-text,.triple-card .card-cta{color:#24282f}.triple-card .card-text p{font-size:1.25rem}.triple-card .card-title{font-size:.75rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
